import { Component, Input } from '@angular/core';
import { TooltipPosition, MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { GoalModel } from '@bp-core/src/lib/proto/common-message.pb';
import { GoalInfo } from 'bp/modules/goal/models/goal-info.model';
import { UtilityService } from 'bp/shared/services/utility-service.service';
import { MatIconModule } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'bp-goal-actions',
    templateUrl: './goal-actions.component.html',
    styleUrls: ['./goal-actions.component.scss'],
    standalone: true,
    imports: [
        MatButtonModule,
        NgClass,
        MatTooltipModule,
        MatIconModule,
    ],
})
export class GoalActionsComponent {
  @Input() goalInfo?: GoalInfo;
  @Input() goal?: GoalModel;

  @Input() itemsDirection?: 'row' | 'row-reverse' | 'col' | 'col-reverse';

  @Input() transferButtonOptions?: {
    visible: boolean | undefined;
    text?: string;
    extraClasses?: string;
    tooltipText?: string;
    tooltipPosition?: TooltipPosition;
    disabled?: boolean;
    icon?: string;
    action?: () => any;
  };

  @Input() depositButtonOptions?: {
    visible: boolean | undefined;
    text?: string;
    extraClasses?: string;
    tooltipText?: string;
    tooltipPosition?: TooltipPosition;
    disabled?: boolean;
    icon?: string;
    action?: () => any;
  };

  constructor(private utilityService: UtilityService, private router: Router) {}

  defaultOnTranferOrRescue() {
    this.router.navigate(['/rescue', this.goal?.id]);
  }

  defaultOnInvest() {
    this.utilityService.navigateToInvest(this.goal?.id, this.goalInfo);
  }
}
